import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import SmartWMSReceive from 'components/Sales/Smart/WarehouseTransfer/WMSReceive';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { getWarehouseCodeFromCache } from 'utils';

export default function SmartWHT(): JSX.Element {
  return (
    <ContentLayout 
      titleKey="titles.receivetransfer" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    >
      {<SmartWMSReceive />}
    </ContentLayout>
  );
}
